import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment, HttpHeadersService } from '@perval/shared';
import { firstValueFrom, map } from 'rxjs';
import { ServicePerval } from '../models/service-perval';
import { fromServicePervalHttpToDomain } from './mapper/service-perval.mapper';

export interface ServicePervalHttp {
  items: ServicePervalItemHttp[];
  total_result: number;
}

export interface ServicePervalItemHttp {
  happened_at: string;
  service: string;
  property_type: string;
  street: string;
  city: string;
  postal_code: string;
  history_id: string;
  evaluation_id: string;
  report_id: string;
}

@Injectable({
  providedIn: 'root',
})
export class ServicePervalService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-services`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  public async getServicesPervalHistory(
    searchParams?: ServicePerval.SearchParams,
    limit = 20,
    offset = 0,
    sort: { key: string; direction: 'asc' | 'desc' } = {
      key: 'happened_at',
      direction: 'desc',
    },
  ): Promise<ServicePerval.History> {
    return firstValueFrom(
      this.http
        .get<ServicePervalHttp>(`${this.mainUrl}/services`, {
          headers:
            await this.httpHeadersServiceService.getHeadersWithPervalContext(),
          params: {
            ...searchParams,
            limit: limit.toString(),
            offset: offset.toString(),
            sort: `${sort.key}.${sort.direction}`,
          },
        })
        .pipe(
          map((serviceHistoryHttp) => ({
            items: serviceHistoryHttp.items.map(fromServicePervalHttpToDomain),
            totalResult: serviceHistoryHttp.total_result,
          })),
        ),
    );
  }
}
